import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import { Footer } from "../components/Footer";
import Navigator from "../components/Navigator";
import Typography from '@mui/material/Typography'
import { CardForm } from "../components/CardForm";
import PlanInfo from "../components/PlanInfo";
import Grid from "@mui/material/Grid";
import { AppContext } from "../context";
import { useContext, useEffect, useState } from "react";
import LeadInfo from "../components/LeadInfo";
import { PrimaryButton } from "../components/PrimaryButton";
import { Button, Checkbox, FormControlLabel } from "@mui/material";
import AlertField from "../components/Alert";
import { MaskInput } from "../components/MaskInput";
import { TextInput } from "../components/Input";
import { useHistory } from "react-router-dom";
import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { SelectInput } from "../components/SelectInput";


export default function PaymentPage() {
  const { logo, lead, checkout, subscribed, plan, updateEvent, updateLead } = useContext<any>(AppContext);
  const history = useHistory();
  const [openAlert, setOpenAlert] = useState<boolean>(false)
  const [alertMessage, setAlertMessage] = useState<string>('')
  const [openDialog, setOpenDialog] = useState(false);
  const [cardBrand, setCardBrand] = useState('');
  const [cardNumber, setCardNumber] = useState('');
  const [cardName, setCardName] = useState('');
  const [cardSecurity, setCardSecurity] = useState('');
  const [cardExpiry, setCardExpiry] = useState('');

  useEffect(() => {
    updateEvent({type: 'SQL', leadId: lead.leadId})
    updateLead({sql: true})
  },[])
    const handleClose = () => {
      setOpenAlert(false)
    }

    const brandOptions = [
      {value: 'Visa', label: 'Visa'},
      {value: 'Master', label: 'Master'},
      {value: 'Amex', label: 'Amex'},
      {value: 'Elo', label: 'Elo'},
      {value: 'Aura', label: 'Aura'},
      {value: 'JCB', label: 'JCB'},
      {value: 'Diners', label: 'Diners'},
      {value: 'Diners', label: 'Discover'},
      {value: 'Diners', label: 'Hipercard'},
    ]

    const handleClick = async (e: any) => {
    e.preventDefault();
      
      const data = {
        cpf: lead.cpf.replace(/\D/g, ""),
        leadId: lead.leadId,
        amount: parseInt(plan.price.replace('.', '')),
        cardNumber:cardNumber,
        cardName: cardName,
        cardSecurity: cardSecurity,
        cardBrand: cardBrand,
        cardExpiry: cardExpiry,
        // checkBox: e.target?.checkBox.value
      }
      console.log(data)
      if (!data.cardBrand) {
        setAlertMessage('Bandeira não informado!')
        setOpenAlert(true)
      } else if (!data.cardNumber) {
        setAlertMessage('Número não informado!')
        setOpenAlert(true)
      } else if (!data.cardName) {
        setAlertMessage('Nome do titular não informado!')
        setOpenAlert(true)
      } else if (!data.cardSecurity) {
        setAlertMessage('CVC não informado!')
        setOpenAlert(true)
      } else if (!data.cardExpiry) {
        setAlertMessage('Validade não informado!')
        setOpenAlert(true)
      } else if (data.cardExpiry.split('/')[1].replace("_", "").length !== 4) {
        setAlertMessage('Validade em formato invalido!')
        setOpenAlert(true)
      } else {
        updateEvent({type: 'SQL_PGTO', leadId: lead.leadId})
        updateLead({sql_payment: true})
        const metaData = {
          cpf: lead.cpf.replace(/\D/g, ""),
          leadId: lead.leadId,
          amount: parseInt(plan.price.replace('.', '')),
          cardNumber:cardNumber.replace(' ', ""),
          cardName: cardName,
          cardSecurity: cardSecurity,
          cardBrand: cardBrand,
          cardExpiry: cardExpiry,
          // checkBox: e.target?.checkBox.value
        }
        const res = await checkout(metaData)
        if (res.success) {
          await subscribed(lead.leadId)
          updateEvent({type: 'SUBSCRIBED', leadId: lead.leadId})
          history.push('/sucesso')
        } 
        if (!res.success){
          history.push('/falha')
        }
      }
    }
  return (
   
      <Container component="main" maxWidth="lg">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 5,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        > 
         <Navigator step={3} />
          <Box >
            <img src={logo} alt=""  style={{margin: '4vh 0 0'}}/>
          </Box>
          <Typography sx={{
            textAlign: 'center',
            color: 'primary.main', 
            mt: 3, 
            mb: 2,
            mx: 5,
            alignContent: 'center'
            }} 
            variant='h4'>
            Chegamos na reta final!
          </Typography>
          <Typography sx={{color: 'primary.main', marginTop: '5vh'}}variant='h6'>
            Informe os dados de pagamento:
          </Typography>
          {/* <CardForm /> */}
          <form onSubmit={handleClick} >
         {/* <DialogBox status={openDialog} handle={handleCloseDialog} /> */}
        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
          <AlertField message={alertMessage} status={openAlert} handle={handleClose} />
        </Box>
          <Box  sx={{ display: 'flex', alignItems: 'flex-end'}}>
            <CreditCardOutlinedIcon sx={{ color:"#656565", mr: 1, my: 1.5 }} />
            <SelectInput
             label="Bandeira"
             id="brand"
             options={brandOptions}
             handleClick={setCardBrand}
           />
          </Box>
          <Box  sx={{ display: 'flex', alignItems: 'flex-end'}}>
            <CreditCardOutlinedIcon sx={{ color:"#656565", mr: 1, my: 1.5 }} />
            <MaskInput
             handle={setCardNumber}
             mask='9999 9999 9999 9999' 
             id='cardNumber'
             label='Número do cartão' />
          </Box>
          <Box  sx={{ display: 'flex', alignItems: 'flex-end'}}>
            <AccountCircleOutlinedIcon sx={{ color:"#656565", mr: 1, my: 1.5 }} />
            <TextInput handle={setCardName} id='cardName' label='Nome do titular'  />
          </Box>
          <Box  sx={{ display: 'flex', alignItems: 'flex-end'}}>
            <CalendarTodayOutlinedIcon sx={{ color:"#656565", mr: 1, my: 1.5 }} />
            <MaskInput handle={setCardExpiry} mask='99/9999' id='cardValidate' label='Validade' />
          </Box>
          <Box  sx={{ display: 'flex', alignItems: 'flex-end'}}>
            <LockOutlinedIcon sx={{ color:"#656565", mr: 1, my: 1.5 }} />
            <TextInput handle={setCardSecurity} id='cvc' label='CVC' />
          </Box>
          {/* <Box max-width={120} sx={{
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'center',
            alignContent: 'center',
            width: '290px',
            mt: 3 
          }}>
          <FormControlLabel max-width={120} control={<Checkbox 
                                                      id='checkBox'
                                                      value='checked' />} label='' />
          <button onClick={handleOpenDialog} 
          style={{background: 'transparent', 
          border: '0px',
          cursor: 'pointer'}}
          >
          <Typography
           sx={{color: '#656565',fontSize: '10px', marginBottom: '-1vh'}}
           variant='subtitle2'
           align='justify'>
          Li e concordo com as regras deste seguro, 
          declaração de veracidade das informações e 
          conhecimento das Condições Gerais.
          </Typography>
          </button>
          </Box> */}
          </form>
          <Typography
           sx={{color: 'primary.main', my: 3}}
           variant='subtitle1'
           align='center'>
          Vamos revisar e garantir que está tudo certo com a sua compra?
          </Typography>
          <Grid container sx={{maxWidth: 700}} spacing={1} direction='row'>
            <Grid xs={12} sm={6}  item>
              <PlanInfo />
            </Grid>
            <Grid xs={12} sm={6} item>
              <LeadInfo 
                name={lead.name}
                cpf={lead.cpf}
                birthdate={lead.birthday}
                cep={lead.address_cep}
                street={lead.address_street}
                number={lead.address_number}
                email={lead.email}
                cellphone={lead.cellphone} />
              </Grid>
            </Grid>
        </Box>
        <Box  sx={{ display: 'flex', alignItems: 'flex-end' }}>
        <Button sx={{margin: 'auto', my: 4, width: 150}}
          variant="contained" 
          color='primary'
          onClick={handleClick}>Contratar
        </Button>
        </Box>
        {/* <Box  sx={{ display: 'flex', alignItems: 'flex-end' }}>
            <PrimaryButton name='Contratar' />
          </Box> */}
        <Box sx={{width:'100wv',
                  alignItems: "center"}}>
        <Footer />
        </Box>
      </Container>
  );
}
